import React from 'react';

import Room from '../room';

import FS from './images/familiar-superior.jpg';
import FS1 from './images/familiar-superior.1.jpg';
import FS2 from './images/familiar-superior.2.jpg';
import FS3 from './images/familiar-superior.3.jpg';
import FS4 from './images/familiar-superior.4.jpg';
import FS5 from './images/familiar-superior.5.jpg';
import FS6 from './images/familiar-superior.6.jpg';
import FS7 from './images/familiar-superior.7.jpg';
import FS8 from './images/familiar-superior.8.jpg';

const SuperiorFamiliar = () => {

  const images = [
    { original: FS, thumbnail: FS },
    { original: FS1, thumbnail: FS1 },
    { original: FS2, thumbnail: FS2 },
    { original: FS3, thumbnail: FS3 },
    { original: FS4, thumbnail: FS4 },
    { original: FS5, thumbnail: FS5 },
    { original: FS6, thumbnail: FS6 },
    { original: FS7, thumbnail: FS7 },
    { original: FS8, thumbnail: FS8 },
  ]

  return (
    <Room title="Superior Familiar" images={images} capacity={4}>
      <p className="p-services">Creada para alojar una familia, la habitación cuenta con cama matrimonial y dos camas twin.</p>
      <p className="p-services">Todas nuestras habitaciones están equipadas con TV por cable, WiFi, cofre de seguridad, calefacción central, aire acondicionado frío/calor, mini bar.</p>
    </Room>
  );
};

export default SuperiorFamiliar;



// WEBPACK FOOTER //
// ./src/rooms/superior-familiar/index.js